import styled from 'styled-components'

import SmallCard from './smallCard'
import square from '../../styles/mixins/cards/square'

export default styled(SmallCard)`
  ${square}
`
